








































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';

@Component
export default class InlineImages extends Vue {
    @Prop() public images: any;
    @Prop() public readFromBlob: boolean;
    @Prop({ default: true }) public shouldParseBase64Prefix: boolean;
    @Prop() public enableDeletion: boolean;
    @Prop({ default: false }) public serverUpload: boolean;
    @Prop({ default: false }) public serverBulkUpload: boolean;
    @Prop({ default: false }) public showAlwaysAllImages: boolean;

    public showAllImages: boolean = false;
    public paginationLimit: number = 3;
    public galleryImages: any = [];

    constructor() {
        super();
    }

    @Watch('images')
    public imagesChanged() {
        this.copyImages();
    }

    get fileUploadProgress(): number {
        return this.$store.getters['FileUpload/getFileUploadProgress'];
    }

    get hasPagination(): boolean {
        return this.galleryImages.length > this.paginationLimit && !this.showAlwaysAllImages;
    }

    get paginatedImages(): string[] {
        return this.hasPagination && !this.showAllImages && !this.showAlwaysAllImages
            ? this.galleryImages.slice(0, this.paginationLimit)
            : this.galleryImages;
    }

    get isFileUploading(): boolean {
        return this.serverUpload && this.fileUploadProgress !== null;
    }

    public copyImages() {
        this.galleryImages = [];

        this.images.forEach((image: any) => {
            this.galleryImages.push(this.setAttacheSrc(image));
        });
    }

    public imageSelected(index: number, image: any) {
        this.$store.commit(Mutations.SHOW_IMAGE_VIEWER, image);
        this.$emit('imageSelected', index);
    }

    public setAttacheSrc(src: any)  {
        if (!this.shouldParseBase64Prefix) {
            return src;
        }

        return (!this.readFromBlob)
            ? src.base64.includes('data:image/png;charset=utf-8;base64,')
                ? src.base64
                : 'data:image/png;charset=utf-8;base64,' + src.base64
            : URL.createObjectURL(src);
    }

    public mounted() {
        this.copyImages();
    }
}
